import { useQuery } from "@tanstack/react-query";
import {
  NaceDivisionBasicDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_NACE } from "../domain";

import { naceApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_NACE_DIVISIONS = "GET_NACE_DIVISIONS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetNaceDivisionsRequest {
  naceSectionId: string;
}

const getNaceDivisions = async (
  params: GetNaceDivisionsRequest,
): Promise<NaceDivisionBasicDto[]> => {
  const { naceSectionId } = params;

  const response = await naceApi.naceControllerGetNaceDivisions(naceSectionId);

  return response.data;
};

export const useGetNaceDivisions = (
  user: UserProfileDto | null,
  params: GetNaceDivisionsRequest,
): {
  naceDivisions: NaceDivisionBasicDto[];
  naceDivisionsEnabled: boolean;
  isSuccessGetNaceDivisions: boolean;
  isPendingGetNaceDivisions: boolean;
} => {
  const hasValidSectionId = !!params.naceSectionId;
  const enabled = roleGuard(user, allowedRoles) && hasValidSectionId;
  const {
    isPending,
    isSuccess,
    data = [],
  } = useQuery({
    queryKey: [DOMAIN_NACE, ACTION_GET_NACE_DIVISIONS, params.naceSectionId],
    queryFn: () => getNaceDivisions(params!),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    naceDivisions: data,
    naceDivisionsEnabled: enabled,
    isPendingGetNaceDivisions: isPending,
    isSuccessGetNaceDivisions: isSuccess,
  };
};
